import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createSplashScreen = (
	backgroundTexture: PIXI.Texture,
	startButtonTexture: PIXI.Texture,
	instructionButtonTexture: PIXI.Texture,
	setInstructionButtonVisibility: (visibility: boolean) => void,
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	globalState: MutableRefObject<FBRTypes.GlobalState>,
) => {
	const splashScreenContainer = new PIXI.Container();

	const backgroundSprite = PIXI.Sprite.from(backgroundTexture);
	backgroundSprite.x = 0;
	backgroundSprite.y = 0; 
	
	const startButtonSprite = PIXI.Sprite.from(startButtonTexture);
	startButtonSprite.interactive = true;
	startButtonSprite.anchor.set(0.5, 0.5);
	startButtonSprite.x = FBRConstants.STAGE_WIDTH/2;
	startButtonSprite.y = FBRConstants.STAGE_HEIGHT - 300;

	startButtonSprite.on('pointerover', () => {
		startButtonSprite.scale.set(1.07, 1.07);
	});
	
	startButtonSprite.on('pointerdown', () => {
		startButtonSprite.tint = 0x4242aa;
	});
	
	startButtonSprite.on('pointerout', () => {
		startButtonSprite.scale.set(1, 1);
		startButtonSprite.tint = 0xFFFFFF;
	});

	startButtonSprite.on('pointerdown', () => {
		globalState.current.score = FBRConstants.GLOBAL_STATE_DEFAULT.score;
		globalState.current.level = FBRConstants.GLOBAL_STATE_DEFAULT.level;
		globalState.current.gameState = 'running';
		globalState.current.gameStartTime = Date.now();
		globalState.current.maxTileValue = FBRConstants.GLOBAL_STATE_DEFAULT.maxTileValue;
		//console.log('game started');
	});
	
	const instructionButtonSprite = PIXI.Sprite.from(instructionButtonTexture);
	instructionButtonSprite.interactive = true;
	instructionButtonSprite.anchor.set(0.5, 0.5);
	instructionButtonSprite.x = FBRConstants.STAGE_WIDTH/2;
	instructionButtonSprite.y = FBRConstants.STAGE_HEIGHT - 215;

	instructionButtonSprite.on('pointerover', () => {
		instructionButtonSprite.scale.set(1.07, 1.07);
	});
	
	instructionButtonSprite.on('pointerdown', () => {
		instructionButtonSprite.tint = 0x4242aa;
	});
	
	instructionButtonSprite.on('pointerout', () => {
		instructionButtonSprite.scale.set(1, 1);
		instructionButtonSprite.tint = 0xFFFFFF;
	});

	instructionButtonSprite.on('pointerdown', () => {
		setInstructionButtonVisibility(true);
	});

	splashScreenContainer.addChild(backgroundSprite);	
	splashScreenContainer.addChild(startButtonSprite);	
	splashScreenContainer.addChild(instructionButtonSprite);	

	const _update = () => {
		if(globalState.current.gameState == 'splash') {
			splashScreenContainer.visible = true;
		} else {
			splashScreenContainer.visible = false;
		}
	}
	
	return {
		container: splashScreenContainer,
		update: _update,
	};
};

export default createSplashScreen;
